import _ from "lodash";
import React from "react";
import { compose, graphql } from "lib/apolloClient";
import { connect } from "react-redux";
import withLoader from "UIComponents/GqlWithLoader";
import I18nHOC from "UIComponents/I18nHOC";
import { goToRelativeRoute, setIsPageNotFound } from "modules/Services";
import { goToPlatformHomeChildRoute } from "modules/NavigationModule";
import {
  logoutUser,
  setChildStatus,
  switchChild,
  setIsUnmappedParent,
} from "Login/modules/LoginModule";
import { Button, EmptyState } from "@toddle-edu/ds-web";
import { getChildrenQuery } from "modules/CommonQuery";
import { Error404Illustration } from "@toddle-edu/ds-theme";
import { FAMILY_INVITE_STATUS_INVITED } from "Constants/stringConstants";

class PageNotFound extends React.Component {
  handleRedirectionForUnauthorizedParent = () => {
    const {
      setIsPageNotFound,
      setChildStatus,
      switchChild,
      goToPlatformHomeChildRoute,
      childData,
      setIsUnmappedParent,
    } = this.props;
    // if family has other children, switch to the first child
    if (!_.isEmpty(childData)) {
      const selectedChildData = _.head(childData);
      const curriculumProgramId = _.get(
        selectedChildData,
        "curriculumPrograms[0].id",
        ""
      );
      goToPlatformHomeChildRoute({ route: "", curriculumProgramId });
      switchChild({ childData: selectedChildData });
    }
    // if family has no children, switch to the add child modal
    else {
      switchChild({ childData: {} });
      setChildStatus(false);
      goToPlatformHomeChildRoute({ route: "" });
    }
    setIsPageNotFound(false);
    setIsUnmappedParent(false);
  };

  goToHomePage = () => {
    const { goToRelativeRoute, setIsPageNotFound } = this.props;
    goToRelativeRoute({ route: "/", type: "replace" });
    setIsPageNotFound(false);
  };

  render() {
    const { t, isUnmappedParent } = this.props;
    const errorText = _.get(
      this.props,
      "errorText",
      // "Woops, that’s an error"
      t("common:page_not_found_header_text")
    );
    const errorSubText = _.get(
      this.props,
      "errorSubText",
      // "We couldn’t find the page you were looking for."
      t("common:page_not_found_sub_text")
    );
    const errorImageSrc = _.get(
      this.props,
      "errorImageSrc",
      Error404Illustration
    );

    //if a family member is removed from student call handleRedirectionForUnauthorizedParent
    const onRedirectButtonClick = isUnmappedParent
      ? this.handleRedirectionForUnauthorizedParent
      : _.get(this.props, "onRedirectButtonClick", this.goToHomePage);

    return (
      <EmptyState
        secondaryButton={
          <Button onClick={logoutUser}>{t("common:logout")}</Button>
        }
        primaryButton={
          <Button onClick={onRedirectButtonClick}>
            {t("common:go_to_homepage")}
          </Button>
        }
        illustration={errorImageSrc}
        size="large"
        title={errorText}
        subtitle={errorSubText}
      />
    );
  }
}

const mapStateToProps = state => {
  const { userInfo, isUnmappedParent } = _.get(state, "login", {});
  return {
    userId: _.get(userInfo, "id", ""),
    isUnmappedParent,
    isData: true,
    isLoading: false,
  };
};
const mapActionCreators = {
  goToRelativeRoute,
  setIsPageNotFound,
  setChildStatus,
  switchChild,
  goToPlatformHomeChildRoute,
  setIsUnmappedParent,
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getChildrenQuery, {
    name: "getChildren",
    skip: ({ isUnmappedParent }) => !isUnmappedParent,
    options: ({ userId }) => ({
      fetchPolicy: "network-only",
      variables: {
        id: userId,
        type: "FAMILY_MEMBER",
        includeInvitedStudents: true,
      },
    }),
    props({ getChildren, ownProps: { isData, isLoading } }) {
      const childrenData = _.get(getChildren, "node", {});
      const children = _.get(childrenData, "children", []);
      const childData = _.filter(
        children,
        childInfo =>
          _.get(childInfo, "parentStatus") !== FAMILY_INVITE_STATUS_INVITED
      );

      return {
        isData: !_.isEmpty(childrenData) && isData,
        isLoading:
          _.includes([1, 2], getChildren["networkStatus"]) || isLoading,
        childData,
      };
    },
  }),
  withLoader
)(PageNotFound);
